import { z } from 'zod';
import { PAYMENT_METHODS } from '../constants';
import { paginationQuerySchema, phoneSchema, santimSchema, text } from './common';

/** Reference IDs are normalized to upper case so duplicates cannot hide behind casing. */
export const referenceIdSchema = z
  .string()
  .trim()
  .min(4)
  .max(64)
  .regex(/^[A-Za-z0-9_-]+$/, 'Reference may contain letters, digits, "-" and "_"')
  .transform((v) => v.toUpperCase());

export const createTopUpSchema = z.object({
  method: z.enum(PAYMENT_METHODS),
  /** Santim. The minimum is enforced against Config in the service. */
  amount: santimSchema,
  referenceId: referenceIdSchema,
  senderName: text(1, 100).optional(),
  senderPhone: phoneSchema.optional(),
  /** Filename returned by POST /uploads/receipt. */
  receiptFile: z
    .string()
    .regex(/^[A-Za-z0-9-]{8,64}\.(jpg|png|webp)$/)
    .optional(),
});
export type CreateTopUpBody = z.infer<typeof createTopUpSchema>;

/** Test deposit: the amount, in santim, to credit immediately. */
export const instantTopUpSchema = z.object({
  amount: santimSchema,
});
export type InstantTopUpBody = z.infer<typeof instantTopUpSchema>;

export const createWithdrawalSchema = z.object({
  method: z.enum(PAYMENT_METHODS),
  accountName: text(2, 100),
  accountNumber: z
    .string()
    .trim()
    .min(4)
    .max(34)
    .regex(/^[A-Za-z0-9\-+ ]+$/, 'Invalid account number'),
  amount: santimSchema,
});
export type CreateWithdrawalBody = z.infer<typeof createWithdrawalSchema>;

export const walletListQuerySchema = paginationQuerySchema;
export type WalletListQuery = z.infer<typeof walletListQuerySchema>;
